module.exports = __webpack_public_path__ + "static/media/Beach10.81f46501.jpg";